type ZoyaLoaderProps = {
  label: string;
  size?: number;
  showLabel?: boolean;
  className?: string;
};

/** Accessible, bilingual request feedback using the Zoya motion language. */
export function ZoyaLoader({
  label,
  size = 48,
  showLabel = true,
  className,
}: ZoyaLoaderProps) {
  return (
    <span
      className={["zoya-request-loader", className].filter(Boolean).join(" ")}
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <span
        className="zoya-loader"
        style={{ width: size, height: size }}
        aria-hidden="true"
      >
        <span className="zoya-loader__ring zoya-loader__ring--outer" />
        <span className="zoya-loader__ring zoya-loader__ring--inner" />
      </span>
      {showLabel ? (
        <span className="zoya-request-loader__label" aria-hidden="true">
          {label}
        </span>
      ) : null}
    </span>
  );
}
